import config from '../config/config';
import { getToken } from '../utils/prefix';
export async function taskAccess(action, data) {
  const response = await fetch(`${config.api_backend}/task/access/${action}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'x-access-token': getToken() || '' },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'ไม่สามารถดำเนินการได้');
  return result;
}

// Keep the user gesture while fetching a scoped URL for private task files.
export async function openTaskFile(url, taskId, isPrivate) {
  const parsed = new URL(url, window.location.href);
  const isTaskFile = /^\/(?:api\/)?(?:data|image)\/(?:datasets|medias)\//.test(parsed.pathname);
  if (!isPrivate || !isTaskFile) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  const popup = window.open('about:blank', '_blank');
  if (popup) popup.opener = null;
  try {
    const result = await taskAccess('file-url', { task_id: taskId, url: parsed.href });
    if (popup) popup.location.replace(result.url);
    else window.location.assign(result.url);
  } catch (error) {
    popup?.close();
    throw error;
  }
}
